import "./home.css";

import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { WHO_ARE_WE, SERVICES, TESTIMONIAL, CONTACT } from "../../data/content";
import { PAGE_ROUTES } from "../../utils/stateTypes";
import Reveal from "../general/Reveal";
import ContactForm from "../general/ContactForm";
import { ImageBand, ContactDetails } from "../general/PageParts";

const Home = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Business Mentorship | PM Skillshouse Foundation | Gauteng</title>
      </Helmet>

      <section
        className={"home-hero parallax"}
        style={{ "--bg-image": "url(/images/hero.jpg)" }}
        aria-label={"PM Skills Foundation"}
      >
        <Reveal
          variant={"fade"}
          className={"home-hero-logo"}
        >
          <h1 className={"sr-only"}>PM Skills Foundation - Impact. Difference.</h1>
          <img
            src={"/images/logo_box.png"}
            alt={""}
            width={593}
            height={577}
          />
        </Reveal>
      </section>

      <section className={"home-who"}>
        <Reveal className={"container home-who-inner"}>
          <span className={"slash"} />
          <h2 className={"section-heading"}>{WHO_ARE_WE.title}</h2>
          <p>{WHO_ARE_WE.text}</p>
        </Reveal>
      </section>

      <ImageBand image={"/images/home_meeting.jpg"} />

      <section className={"home-services"}>
        <div className={"container"}>
          <Reveal>
            <span className={"slash home-services-slash"} />
            <h2 className={"section-heading"}>SERVICES</h2>
          </Reveal>
          <div className={"home-services-grid"}>
            {SERVICES.map((service, i) => (
              <Reveal
                key={service.id}
                delay={i * 0.1}
              >
                <Link
                  to={`${PAGE_ROUTES.SERVICES}#${service.id}`}
                  className={"home-service-tile"}
                >
                  <span className={"home-service-num"}>{`0${i + 1}`}</span>
                  <span className={"home-service-name"}>{service.title}</span>
                </Link>
              </Reveal>
            ))}
          </div>
          <div className={"home-services-more"}>
            <Link
              to={PAGE_ROUTES.SERVICES}
              className={"btn btn-outline"}
            >
              OUR SERVICES
            </Link>
          </div>
        </div>
      </section>

      <section
        className={"home-testimonial parallax"}
        style={{ "--bg-image": "url(/images/testimonial.jpg)" }}
        aria-label={"Testimonial"}
      >
        <Reveal
          as={"blockquote"}
          className={"container"}
        >
          <p>{TESTIMONIAL}</p>
        </Reveal>
      </section>

      <section className={"home-contact"}>
        <div className={"container"}>
          <Reveal>
            <h2 className={"home-contact-title"}>{CONTACT.homeTitle}</h2>
          </Reveal>
          <div className={"home-contact-grid"}>
            <Reveal variant={"left"}>
              <ContactDetails />
            </Reveal>
            <Reveal
              variant={"right"}
              delay={0.1}
            >
              <ContactForm variant={"light"} />
            </Reveal>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Home;
